import { Reducer } from "redux";

import { MasterCareTypeResponse } from "../models/api/Master";
import { MasterCareTypeDispatchTypes } from "../models/dispatchTypes/Master";
import { MasterCareTypeActionDispatchTypes } from "../constants/Master";

const initialState: MasterCareTypeResponse = {
  loading: false,
  response: [],
  error: null
};

const MasterCareTypeReducer: Reducer<
MasterCareTypeResponse,
MasterCareTypeDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterCareTypeActionDispatchTypes.MASTER_CARE_TYPE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MasterCareTypeActionDispatchTypes.MASTER_CARE_TYPE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case MasterCareTypeActionDispatchTypes.MASTER_CARE_TYPE_ERRORS: {
      return initialState;
    }
  }
  return state;
};

export default MasterCareTypeReducer;
